import { MediaType } from '../../../constants/MediaType';
import { Orientation } from '../../../constants/Orientation';
export function parseFolderId(folderId) {
  const [parsedMediaType, orientation, category, color] = (folderId || '').split('_');
  const mediaType = hasInOr(parsedMediaType, [MediaType.Video, MediaType.Picture], MediaType.Picture);
  return {
    mediaType,
    orientation: mediaType === MediaType.Picture ? hasInOr(orientation, [Orientation.Vertical, Orientation.Horizontal], null) : null,
    category: category === 'any' ? null : category,
    color: mediaType === MediaType.Picture ? color : null // Color supported only for pictures
  };
}
function hasInOr(value, range, defaultValue) {
  return range.indexOf(value) === -1 ? defaultValue : value;
}